export const getPersonDeleteApiData = (records: Array<any>) => {
  return {
    personIds: records.filter((x) => x.personId).map((x) => x.personId) || undefined,
    dcPersonIds: records.filter((x) => x.dcPersonId).map((x) => x.dcPersonId) || undefined,
  };
};
